var focusableElementsSelector = [
    'a[href]',
    'button',
    'input',
    'textarea',
    'select',
    'details',
    '[tabindex]',
]
    .map(function (item) {
    return "".concat(item, ":not(:disabled):not([tabindex=\"-1\"]):not([type=\"hidden\"])");
})
    .join(',');
/** Select focusable elements within container */
export function selectFocusableChildren(element) {
    return element.querySelectorAll(focusableElementsSelector);
}
//# sourceMappingURL=selectFocusableChildren.js.map